import { render, staticRenderFns } from "./AppUserNavigation.vue?vue&type=template&id=2a4c3178&scoped=true"
import script from "./AppUserNavigation.vue?vue&type=script&lang=ts"
export * from "./AppUserNavigation.vue?vue&type=script&lang=ts"
import style0 from "./AppUserNavigation.vue?vue&type=style&index=0&id=2a4c3178&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4c3178",
  null
  
)

export default component.exports